<template>
  <div class="page-content revenue-goal">
    <h1 class="page-title">{{ $locale('sideMenu.reports.revenueGoal') }}</h1>

    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col class="makeInline" :lg="16" :md="24">
        <DatePickerGroup
          v-bind:start="filter.startDate"
          v-bind:end="filter.endDate"
          v-bind:max="Infinity"
          @setFatherDate="getDate"
        ></DatePickerGroup>
        <el-button class="egl-btn-yellow" @click="searchClick">{{ isGetList ? $locale("global.search") : $locale("global.select") }}</el-button>
      </el-col>
      <el-col class="ta-r" :lg="8" :md="24">
        <el-button class="egl-btn-yellow" @click="exportCSV_fn" :disabled="!downloadCSV">{{$locale('global.exportToCSV')}}</el-button>
        <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
      </el-col>
    </el-row>
    <div id="print">
      <div class="table-box" v-if="isGetList">
      <el-table :data="tableData" class="egl-table" stripe max-height="500" border>
        <template v-for="(th, colIndex) in thead">
          <el-table-column
            :fixed="colIndex == 0"
            :prop="th.prop"
            :label="th.label"
            :key="th.prop"
            :width="th.width"
            v-if="!th.isInput">
          </el-table-column>
          <el-table-column
            :fixed="colIndex == 0"
            :label="th.label"
            :key="th.prop"
            :width="th.width"
            v-else>
            <template slot-scope="scope">
              <el-input
                v-model="scope.row[th.prop]"
                :readonly="scope.$index == tableData.length - 1"
                @blur="getRate(scope.$index, th.prop)"
                @keyup.enter.native="getRate(scope.$index, th.prop)"
              ></el-input>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    </div>
    

    <div class="detail-page-btn" v-if="isGetList">
      <el-button class="egl-btn-white">{{ $locale("global.cancel") }}</el-button>
      <el-button class="egl-btn-yellow" @click="save_fn">{{ $locale("global.save") }}</el-button>
    </div>
  </div>
</template>
<style scoped>
.el-col {
  margin-bottom: 5px;
}
.makeInline {
  white-space: nowrap;
}
</style>

<script>
import DatePickerGroup from "@/components/DatePickerGroup";
import { thead_fn, formatData, checkData } from "@/assets/js/revenueGoal.js";
import { getRevenueGoalList, saveRevenueGoal } from "@/helpers/service/api/revenueGoal.js";
import { getExportName_fn } from '@/utils/common'
import { weekLocaleArray } from "@/utils/common";


export default {
  name: "RevenueGoal",
  data() {
    return {
      printObj: {
        popTitle: this.$locale('sideMenu.reports.revenueGoal'),
        id: "print"
      },
      onSearch: {
        startDate: 0,
        endDate: 0,
      },
      filter: {
        startDate: 0,
        endDate: 0,
      },
      thead: [],
      tableData: [],
      originalData: [],
      rateData: [],
      isGetList: false,
      cinemaId: "",
      downloadCSV: false,
      token: "",
    };
  },
  methods: {
    getDate(obj) {
      this.filter = {
        startDate: obj.startDate,
        endDate: obj.endDate,
      };
    },
    searchClick() {
      this.onSearch = { ...this.filter };
      this.search_fn();
    },
    search_fn() {
      let dayList = [];
      let cinemaId = window.localStorage.getItem("cinemaId") || "";

      if (cinemaId == "") {
        this.$emit("callCinema", "search_fn");

        return;
      }
      this.cinemaId = cinemaId;


      for (let i = this.onSearch.startDate; i <= this.onSearch.endDate; i+= 24*60*60*1000) {
        let dayText = this.$moment(i).format("YYYY-MM-DD");
        dayList.push(dayText);
      }

      getRevenueGoalList({
        cinemaId: cinemaId,
        dateList: dayList.toString(),
      }).then(res => {
        if (res.success) {
          this.tableData = formatData(res.data);
          this.originalData = res.data;
          this.rateData = res.data;
          this.isGetList = true;
          this.downloadCSV = true;
        }
      });
    },
    exportCSV_fn() {
      let { cinemaId } = this;
      let dayList = [];
      let queryString = "";
      let { token } = this;

      for (let i = this.onSearch.startDate; i <= this.onSearch.endDate; i+= 24*60*60*1000) {
        let dayText = this.$moment(i).format("YYYY-MM-DD");
        dayList.push(dayText);
      }

      queryString = `cinemaId=${cinemaId}&dateList=${dayList.toString()}`;

      window.fetch("/api/salesGoalTotal/export?" + queryString, {
        method: "GET",
        headers: { "Authorization": token },
        dataType: "blob",
        credentials: "include",
      }).then(response => {
        response.blob().then(blob => {
          const blobUrl = window.URL.createObjectURL(blob);
          const aElement = document.createElement("a");
          aElement.href = blobUrl;
          aElement.download = 
          // `${this.$moment().format("YYYYMMDDHHmm")}_${this.$locale("sideMenu.reports.revenueGoal")}.csv`;
          getExportName_fn(
            this.$locale("sideMenu.reports.revenueGoal"),
            '',
            '',
            '',
            `${this.$moment(this.filter.startDate).format('YYYY-MM-DD')} （${weekLocaleArray[this.$moment(this.filter.startDate).day()]}）~ ${this.$moment(this.filter.endDate).format('YYYY-MM-DD')} （${weekLocaleArray[this.$moment(this.filter.endDate).day()]}）`,
            '',
            this.$moment().format('YYYYMMDDHHmm')
          ) + '.csv'
          aElement.click();
          window.URL.revokeObjectURL(blobUrl);
        });
      }).catch(err => {
        this.$alert(err.message, {
          showClose: false,
        });
      });
    },
    getRate(index, keyName) {
      if (index < this.rateData.length) {
        let dataList = JSON.parse(JSON.stringify(this.rateData));
        let goalNum = this.tableData[index][keyName];
        let dataKeyName = "goalMoney" + keyName.substring(4, keyName.length);
        let originalData = JSON.parse(JSON.stringify(this.originalData));
        let matchArr = [];
        let { downloadCSV } = this;

        if (goalNum == "") {
          goalNum = 0;
        } else {
          goalNum = parseInt(goalNum.replace(/[^0-9]/g, ""));
        }

        dataList[index][dataKeyName] = goalNum || 0;
        matchArr = checkData(originalData, dataList);

        if (matchArr.length > 0) {
          downloadCSV = false;
        } else {
          downloadCSV = true;
        }

        this.tableData = formatData(dataList);
        this.rateData = dataList;
        this.downloadCSV = downloadCSV;
      }
    },
    save_fn() {
      let rateData = JSON.parse(JSON.stringify(this.rateData));
      let originalData = JSON.parse(JSON.stringify(this.originalData));
      let targetData = checkData(originalData, rateData);

      if (targetData.length > 0) {
        targetData.map(obj => {
          obj.id = obj.salesGoalTotalId;
          return obj;
        });

        saveRevenueGoal({ salesGoalInfoList: targetData }).then(res => {
          if (res.success) {
            this.search_fn();
          }
        });
      }
    },
  },
  mounted() {
    const today = this.$moment().valueOf();
    let startDay = this.$moment(today).format("YYYY-MM") + "-01";
    let endDay = this.$moment(startDay).add("months", 1).add("days", -1).format("YYYY-MM-DD");
    const token = window.localStorage.getItem("token");

    this.filter = {
      startDate: this.$moment(startDay).valueOf(),
      endDate: this.$moment(endDay).valueOf(),
    };
    this.token = token;
    this.thead = thead_fn();
  },
  components: {
    DatePickerGroup,
  },
};
</script>
<style lang="less">
.revenue-goal {
  .table-box {
    border-top: 1px dashed #d2d2d2;
    padding: 68px 0 45px 0;

    .egl-table {
      th {
        color: #898989;
        text-align: center;
      }
      tr {
        &:last-child {
          td:first-child {
            background: #f6e8a4;
          }
          .el-input__inner {
            border: 0;
          }
        }

        td {
          text-align: right;

          &:first-child {
            text-align: center;
          }

          .el-input__inner {
            text-align: right;
          }
        }
      }
      .el-table__row {
        td {
          background: #fff7ea;
        }
      }

      .el-table__row--striped {
        td {
          background: #fff;
        }
      }
    }
  }
}
</style>
